import { memo, useMemo } from 'react';

import { Form } from '@components/form';
import { useLocale } from '@locale/translate';

import { RadioField } from './types';
import { getTranslatedFormText } from './utils';

export const RadioInput = memo<{ field: RadioField }>(({ field }) => {
  const currentLanguage = useLocale();

  const options = useMemo(
    () =>
      field.options.map((optionText, index) => ({
        label: getTranslatedFormText(optionText, currentLanguage),
        value: index,
      })),
    [field, currentLanguage],
  );

  return (
    <Form.RadioGroup
      {...field}
      label={getTranslatedFormText(field.text, currentLanguage)}
      options={options}
      defaultValue={field.value}
    />
  );
});
